// Toast.js
import React from 'react';
import './styles/Toast.css'// Make sure to create this CSS file

const Toast = ({ message, onClose }) => {
  return (
    <div className="toast">
      <p>{message}</p>
      <button onClick={onClose}>X</button>
    </div>
  );
};

export default Toast;
